export function roundToDecimals(num: number, decimals: number): number {
  const factor = Math.pow(10, decimals);
  return Math.round(num * factor) / factor;
}
export function roundPrice(num: number) {
  return roundToDecimals(num, 2);
}
